exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/*\n * Переменные\n */\n.test-question-answer-container[data-v-35dd626e] {\n  background: #FAFAFA;\n  border: 1px solid #dedede;\n  border-radius: 6px;\n  width: 100%;\n}\n.test-question-text[data-v-35dd626e] {\n  font-size: 1rem;\n  margin-bottom: 25px;\n}", ""]);

// exports
